import React from 'react';
import { SelectBox } from 'devextreme-react/select-box';
import DateBox from 'devextreme-react/date-box';
import NumericInput from 'react-numeric-input';
import { terminalTypeData } from './constants';

const CharterDetailsCard = React.memo(function CharterDetailsCard({
  state,
  onChange,
  onReservationModeChange,
  onVehicleTypeChange,
  onAirlineChange,
  onFlightHourChange,
  onFlightMinuteChange,
  onPickupDateTimeChange,
  onTripTypeChange,
  onPaxCountChange,
  onTripCountChange,
  onMeetGreetChange,
  rideTypeId,
  vehicleTypeSelectValidatorRef,
  errors,
}) {
  return (
    <div className="rx-card">
      <div className="rx-card-line rx-cl-amber" />
      <div className="rx-card-hd">
        <span className="rx-card-ico rx-ico-amber"><i className="fas fa-plane" /></span>
        <span className="rx-card-title">Charter Details</span>
      </div>
      <div className="rx-card-body">
        <div className="rx-cols-2">
          <div className="rx-fg">
            <label>Reservation Mode <span className="req">*</span></label>
            <SelectBox dataSource={state.dropdownReservationMode} placeholder="Select rez mode" name="reservationModeId" defaultValue={0} value={state.reservationModeId} displayExpr="name" valueExpr="id" onSelectionChanged={onReservationModeChange} showClearButton={true} searchEnabled={true} />
            {errors.reservationModeId.length > 0 && <span className="rx-err">{errors.reservationModeId}</span>}
          </div>
          <div className="rx-fg">
            <label>Vehicle Type <span className="req">*</span></label>
            <SelectBox dataSource={state.dropdownVehicleType} placeholder="Select vehicle type" name="vehicleTypeId" defaultValue={0} value={state.vehicleTypeId} displayExpr="apiVehicleTypeDescription" valueExpr="rowIndex" onSelectionChanged={onVehicleTypeChange} showClearButton={true} searchEnabled={true} ref={vehicleTypeSelectValidatorRef} />
            {errors.vehicleTypeId.length > 0 && <span className="rx-err">{errors.vehicleTypeId}</span>}
          </div>
        </div>
        <div className="rx-cols-3">
          <div className="rx-fg">
            <label>Pax # <span className="req">*</span></label>
            <NumericInput className="form-control form-control-sm" name="noOfPax" value={state.noOfPax} min={1} max={100} onChange={(value) => onPaxCountChange(value)} />
            {errors.noOfPax.length > 0 && <span className="rx-err">{errors.noOfPax}</span>}
          </div>
          <div className="rx-fg">
            <label>Bag #</label>
            <NumericInput className="form-control form-control-sm" name="luggage" value={state.luggage} min={0} max={20} onChange={(value) => onChange({ target: { name: 'luggage', value, type: 'number' } })} />
          </div>
          <div className="rx-fg">
            <label>No. of Trips</label>
            <NumericInput className="form-control form-control-sm" name="noOfTrip" disabled={state.tripTypeId === '2' || state.tripTypeId === '3' || parseInt(state.paymentTermId) === 2 || state.rideId > 0} value={state.noOfTrip} min={1} max={20} onChange={(value) => onTripCountChange(value)} />
            {errors.noOfTrip.length > 0 && <span className="rx-err">{errors.noOfTrip}</span>}
          </div>
        </div>
        <div className="rx-check-row">
          <label className="rx-chk-lbl"><input type="checkbox" id="isAccessible" checked={state.isAccessible} onChange={onChange} name="isAccessible" /> Accessible</label>
          <label className="rx-chk-lbl"><input type="checkbox" id="isPriorityTrip" checked={state.isPriorityTrip} onChange={onChange} name="isPriorityTrip" /> Priority Trip</label>
          <label className="rx-chk-lbl"><input type="checkbox" checked={state.isVipTrip} onChange={onChange} name="isVipTrip" /> VIP</label>
          <label className="rx-chk-lbl"><input type="checkbox" id="isLockRates" checked={state.isLockRates} disabled={state.rideId > 0 && state.paymentTypeId === 2 && state.creditCard.includes('x')} onChange={onChange} name="isLockRates" /> Lock Rates</label>
          {(rideTypeId === 1 || rideTypeId === 3) && (
            <label className="rx-chk-lbl"><input type="checkbox" checked={state.isMeetGreet} onChange={onMeetGreetChange} name="isMeetGreet" /> Meet &amp; Greet</label>
          )}
        </div>
        <div className="rx-cols-4">
          <div className="rx-fg">
            <label>Airline</label>
            <SelectBox dataSource={state.dropdownAirline} placeholder="Select airline" name="airlineId" defaultValue={0} value={state.airlineId} displayExpr="airLineName" valueExpr="airLineId" onSelectionChanged={onAirlineChange} showClearButton={true} searchEnabled={true} />
          </div>
          <div className="rx-fg">
            <label>Flight #</label>
            <input type="text" className="rx-ff" maxLength={25} value={state.flightNumber} onChange={onChange} name="flightNumber" placeholder="Flight #" />
            {errors.flightNumber.length > 0 && <span className="rx-err">{errors.flightNumber}</span>}
          </div>
          <div className="rx-fg">
            <label>Terminal Type</label>
            <select className="rx-ff" name="terminalType" value={state.terminalType} onChange={onChange}>
              <option value="0">Select terminal type</option>
              {terminalTypeData.map((item, i) => (<option key={i} value={item.id}>{item.name}</option>))}
            </select>
          </div>
          <div className="rx-fg">
            <label>Terminal</label>
            <input type="text" className="rx-ff" maxLength={25} value={state.terminal} onChange={onChange} name="terminal" placeholder="Terminal" />
          </div>
        </div>
        <div className="rx-cols-3">
          <div className="rx-fg">
            <label>Flight Time [hh]</label>
            <SelectBox dataSource={state.dropdownHours} placeholder="Select Hour" name="id" defaultValue={0} value={state.flightHour} displayExpr="name" valueExpr="id" onSelectionChanged={onFlightHourChange} showClearButton={true} searchEnabled={true} />
            {errors.flightTime.length > 0 && <span className="rx-err">{errors.flightTime}</span>}
          </div>
          <div className="rx-fg">
            <label>[min]</label>
            <SelectBox dataSource={state.dropdownMinutes} placeholder="Select Minute" name="id" defaultValue={0} value={state.flightMinute} displayExpr="name" valueExpr="id" onSelectionChanged={onFlightMinuteChange} showClearButton={true} searchEnabled={true} />
          </div>
          <div className="rx-fg">
            <label>PU Date &amp; Time <span className="req">*</span></label>
            <DateBox type="datetime" name="puDateTime" placeholder="MM/dd/yyyy HH:mm" displayFormat="MM/dd/yyyy HH:mm" showAnalogClock={true} useMaskBehavior={true} defaultValue={state.puDateTime} value={state.puDateTime} onValueChanged={onPickupDateTimeChange} width="100%" acceptCustomValue={false} />
            {errors.puDateTime.length > 0 && <span className="rx-err">{errors.puDateTime}</span>}
          </div>
        </div>
        <div className="rx-check-row">
          <label className="rx-radio-lbl"><input type="radio" name="oneWay" value="1" checked={state.tripTypeId === '1'} disabled={state.rideId > 0} onChange={onTripTypeChange} /> Oneway</label>
          <label className="rx-radio-lbl"><input type="radio" name="isReturnTrip" value="2" disabled={parseInt(state.paymentTermId) === 2 || state.rideId > 0} checked={state.tripTypeId === '2'} onChange={onTripTypeChange} /> Round Trip</label>
          <label className="rx-radio-lbl"><input type="radio" name="isRecurring" value="3" disabled={parseInt(state.paymentTermId) === 2 || state.rideId > 0} checked={state.tripTypeId === '3'} onChange={onTripTypeChange} /> Recurring</label>
        </div>
      </div>
    </div>
  );
});

export default CharterDetailsCard;
